export const isVersionGte = (current, target) => {
  if (!current || !target) return false;

  const keys = ['major', 'minor', 'patch'];

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const currentValue = current[key] || 0;
    const targetValue = target[key] || 0;

    if (currentValue > targetValue) {
      return true;
    }

    if (currentValue < targetValue) {
      return false;
    }
  }

  return true;
};
